import { useState } from "react";
import "./technology_partners_view.css";
import { technologyPartnersMapper } from "../utils/mapper/technology_partners_mapper.jsx";
import TechnologiesCarousel from "../components/technologies_carousel/technologies_carousel.jsx";
import PartnershipsCarousel from "../components/partnerships_carousel/partnerships_carousel.jsx";

const TechnologyPartnersView = () => {
    const { titles, imagesTechnologies, partnersCarousel, sliderConfig, partnershipSliderConfig, animation } = technologyPartnersMapper;
    const [activeTab, setActiveTab] = useState("technologies");

    return (
        <div className="technologyPartners">
            <div className="bloc_title row">
                <button
                    type="button"
                    className={`col-6 technologies ${activeTab === "technologies" ? "active" : ""}`}
                    onClick={() => setActiveTab("technologies")}
                >
                    <h1>{titles.technologies}</h1>
                </button>
                <button
                    type="button"
                    className={`col-6 partnerships ${activeTab === "partnerships" ? "active" : ""}`}
                    onClick={() => setActiveTab("partnerships")}
                >
                    <h1>{titles.partnerships}</h1>
                </button>
            </div>

            <div className="bloc_carousel" style={{ display: activeTab === "technologies" ? "block" : "none" }}>
                <div key="technologies" className="carousel_content_animate slide_from_left">
                    <TechnologiesCarousel
                        images={imagesTechnologies}
                        sliderConfig={sliderConfig}
                        animation={animation}
                    />
                </div>
            </div>

            {activeTab === "partnerships" && (
                <div className="bloc_carousel">
                    <div key="partnerships" className="carousel_content_animate slide_from_right">
                        <PartnershipsCarousel
                            partners={partnersCarousel}
                            sliderConfig={partnershipSliderConfig}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default TechnologyPartnersView;
